import React from "react";
import { useSelector } from "react-redux";
import style from '../DemolitionServices/DemolitionServices.module.scss';

const CivilWorkOptions = (props) => {
  const { optionsList } = props;
  const { details, isDrawingsExporting, updateDetails, itemDetails, type, defaultText } = props;
  const orderProfileType = useSelector((state: any) => state.wizard.orderProfileType);

  const isDC = ['dc', 'designcafe'].includes(orderProfileType?.toLowerCase());

  const resolvedOptionsList = isDC
    ? optionsList?.map((e: any) => e === 'HL Scope' ? 'DC Scope' : e === 'HomeLane' ? 'DesignCafe' : e)
    : optionsList;

  return (
    <div className={style.option_view}>
      {!isDrawingsExporting ? type === 'input' ? <input value={itemDetails?.[details?.id] || ''} onChange={(v) => updateDetails({ id: details.id, value: v.target.value })} /> : <select className={style.edit_select_options} onChange={(v) => updateDetails({ id: details.id, value: v.target.value })}>
        <option value='' selected>{defaultText || '-'}</option>
        {
          resolvedOptionsList?.map((e: any) => <option value={e} selected={itemDetails?.[details?.id] === e}>{e}</option>)
        }
      </select> : <span>{itemDetails?.[details?.id] || defaultText || '-'}</span>
      }
    </div>
  )
}

export default CivilWorkOptions;